import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';

// Store
import {
  toggleCaptionsStatus,
  toggleCaptionsSuccessStatus,
  toggleCaptionsErrorStatus,
} from './session.actions';

// Services
import { CallService } from '@services/call.service';

@Injectable()
export class SessionEffects {
  private actions$ = inject(Actions);
  private userCallService = inject(CallService);

  toggleCaptionsStatus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(toggleCaptionsStatus),
      switchMap(({ data: { captions, call_id } }) =>
        this.userCallService.toggleCaptionsStatus(captions, call_id).pipe(
          map(() => toggleCaptionsSuccessStatus({ captions })),
          catchError(error => of(toggleCaptionsErrorStatus({ error }))),
        ),
      ),
    ),
  );
}
